<template>
  <div class="lightBackground py-6" :class="screen === 'mobile' ? '' : ''">
    <div
      class="container has-padding-right-20-mobile has-padding-left-20-mobile"
      :class="screen === 'mobile' ? '' : 'padding-0-80px'"
    >
      <div
        class="box is-shadowless pa-0 has-text-black border-bottom-right-radius-16px border-bottom-left-radius-16px border-top-right-radius-16px border-top-left-radius-16px"
      >
        <img
          src="/images/blog_img.png"
          alt="organization image"
          class="border-top-right-radius-16px border-top-left-radius-16px is-full-width height-10rem"
          :class="screen === 'mobile' ? 'object-fit-cover' : 'object-fit-fill'"
        />
        <div
          v-if="Object.keys(employerDetail).length >= 1"
          class="px-3 pt-2 pb-3 is-flex gap-05rem is-content-space-between"
          :class="screen === 'mobile' ? 'is-flex-direction-column' : ''"
        >
          <div class="is-flex gap-05rem">
            <img
              class="is-64x64 image outline is-paddingless logo-radius-5"
              :src="employerDetail.logo || ''"
            />
            <div class="is-size-5 tiro">
              {{ employerDetail.name || '-' }}
              <vue-icon-base
                height="16"
                width="16"
                :path="$options.icons[$kc('uni-tick')]"
                iconColor="#B2512B"
              >
              </vue-icon-base>
              <p class="is-size-7">
                {{
                  (employerDetail.industry && employerDetail.industry.name) ||
                  '-'
                }}
              </p>
            </div>
          </div>
          <div class="is-flex gap-05rem align-center content-end">
            <a
              href="#available-jobs"
              class="button rounded small text-14 text-orange border-orange"
              :class="screen === 'mobile' ? 'width-6rem' : ''"
            >
              {{ $t('View Jobs') }}
            </a>
            <!-- TODO NEW FEATURE -->
            <!-- <button
              class="button text-14 rounded is-jobseeker"
              :class="screen === 'mobile' ? 'width-12rem' : ''"
              @click="$router.push('/signup')"
            >
              {{ $t('Interested to Join ?') }}
            </button> -->
          </div>
        </div>
        <vue-no-data v-else :loading="loading"></vue-no-data>
      </div>
      <div class="columns is-flex-wrap mb-0">
        <div class="column" :class="screen === 'mobile' ? 'is-12' : 'is-8'">
          <div
            class="box has-text-black is-shadowless border-bottom-right-radius-16px border-bottom-left-radius-16px border-top-right-radius-16px border-top-left-radius-16px mukta"
          >
            <h1 class="is-size-4 has-text-weight-semibold">
              {{ $t('About Company') }}
            </h1>
            <hr class="hr-line" />
            <p
              v-if="employerDetail.about"
              class="pa-3 is-full-width has-background-white"
              v-html="employerDetail.about"
            ></p>
            <vue-no-data v-else :loading="loading"></vue-no-data>
          </div>
          <div
            v-if="employerDetail.benefits"
            class="box is-shadowless has-text-black border-bottom-right-radius border-bottom-left-radius border-top-right-radius border-top-left-radius mukta"
          >
            <h1 class="is-size-4 has-text-weight-semibold">
              {{ $t('Benefits') }}
            </h1>
            <hr class="hr-line" />
            <div class="is-flex is-flex-wrap gap-1 text-14">
              <div
                v-for="benefit in employerDetail.benefits || []"
                :key="benefit.id"
                class="width lightBackground px-5 py-2 rounded-10"
                :class="
                  screen === 'mobile'
                    ? 'width-46percent'
                    : 'desktop'
                    ? 'width-16rem'
                    : 'fullhd'
                    ? 'width-19rem'
                    : ''
                "
              >
                {{ benefit.name }}
              </div>
            </div>
          </div>
          <div
            v-if="Object.keys(available_jobs).length >= 1"
            id="available-jobs"
            class="box is-shadowless border-bottom-right-radius-16px border-bottom-left-radius-16px border-top-right-radius-16px border-top-left-radius-16px mukta mb-3"
          >
            <div class="is-flex align-center is-content-space-between">
              <h1 class="is-size-4 has-text-weight-semibold has-text-black">
                {{ $t('Available Jobs') }}
              </h1>
              <div class="text-orange pointer text-14" @click="jobSearch()">
                {{ $t('Browse All Jobs') }}
              </div>
            </div>
            <hr class="hr-line" />
            <div class="is-flex is-flex-wrap gap-05rem pt-3">
              <div
                v-for="job in available_jobs || []"
                :key="job.id"
                class="box is-shadowless outline pa-0 has-text-centered rounded-10 has-text-black is-half-width-image mb-0"
              >
                <div class="is-flex">
                  <img
                    :src="job.organization.logo"
                    class="border-top-left-radius-10px border-bottom-left-radius-10px object-fit-cover job-image-mobile"
                  />
                  <div
                    class="has-text-left text-14 pa-2 is-flex is-flex-direction-column gap-05rem column is-7"
                  >
                    <p>
                      <span
                        class="has-text-weight-bold pointer"
                        @click="
                          $router.push(
                            localePath({
                              name: 'job-jobSlug-detail',
                              params: { jobSlug: job.slug }
                            })
                          )
                        "
                      >
                        {{ $options.truncateChars(job.job_title, 15) }}
                      </span>
                      <span
                        v-if="
                          $store.state.auth.loggedIn &&
                          !$auth.user.employer_profile
                        "
                      >
                        <a
                          class="has-text-success is-pulled-right"
                          @click="toggleLike(job.index, job)"
                        >
                          <vue-icon-base
                            height="14"
                            width="14"
                            :path="
                              job.liked
                                ? $options.icons[$kc('uni-heart-alt')]
                                : $options.icons[$kc('uni-heart')]
                            "
                            icon-color="#c80815"
                          >
                          </vue-icon-base>
                        </a>
                      </span>
                      <span v-else>
                        <a class="is-pulled-right" @click="notify">
                          <vue-icon-base
                            height="14"
                            width="14"
                            :path="$options.icons[$kc('uni-heart')]"
                            icon-color="black"
                          >
                          </vue-icon-base>
                        </a>
                      </span>
                    </p>
                    <p>
                      {{ $options.truncateChars(job.organization.name, 20) }}
                    </p>
                    <p
                      v-for="location in job.job_locations"
                      :key="location.id"
                      :class="screen === 'mobile' ? '' : 'is-flex'"
                    >
                      <vue-icon-base
                        class="mr-2"
                        height="14"
                        width="14"
                        :path="$options.icons[$kc('uni-map-pin-line')]"
                      >
                      </vue-icon-base>
                      {{ $options.truncateChars(location.address, 20) }}
                    </p>
                    <p>
                      <vue-icon-base
                        class="mr-2"
                        height="14"
                        width="14"
                        :path="$options.icons[$kc('uni-user')]"
                      >
                      </vue-icon-base
                      >{{ job.vacancies }} {{ $t('job available') }}
                    </p>
                    <p class="text-orange">
                      {{ $t('Deadline') }}:
                      {{ $options.getMoment(job.deadline) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="pl-3 box is-shadowless border-bottom-right-radius-16px border-bottom-left-radius-16px border-top-right-radius-16px border-top-left-radius-16px mukta has-text-black"
          >
            <h1 class="is-size-4 has-text-weight-semibold">
              {{ $t('Available Jobs') }}
            </h1>
            <hr class="hr-line" />
            <vue-no-data :loading="loading"></vue-no-data>
          </div>
        </div>
        <div class="column" :class="screen === 'mobile' ? 'is-12' : 'is-4'">
          <div
            class="box is-shadowless has-text-black is-flex is-flex-direction-column gap-05rem border-bottom-right-radius-16px border-bottom-left-radius-16px border-top-right-radius-16px border-top-left-radius-16px mukta"
          >
            <h1 class="is-size-5 has-text-weight-semibold">
              {{ $t('Company Info') }}
            </h1>
            <hr class="hr-line" />
            <div class="text-14 is-flex is-flex-direction-column">
              <span class="has-text-weight-bold">
                {{ $t('Company Location') }}: </span
              >{{ employerDetail.location_organization || '-' }}
            </div>
            <div class="text-14 is-flex is-flex-direction-column">
              <span class="has-text-weight-bold"
                >{{ $t('Company Size') }}: </span
              >{{ employerDetail.org_size || '-' }}
            </div>
            <div class="text-14 is-flex is-flex-direction-column">
              <span class="has-text-weight-bold"
                >{{ $t('Social Profiles') }}:
              </span>
              <span class="is-flex gap-05rem">
                <div
                  v-if="
                    employerDetail.social_accounts &&
                    employerDetail.social_accounts.length > 0
                  "
                  class="is-flex gap-05rem"
                >
                  <span
                    v-for="account in employerDetail.social_accounts"
                    :key="account.url"
                    @click="openLink(account.url)"
                    :class="account.account_name ? 'pointer' : ''"
                  >
                    <vue-icon-base
                      height="16"
                      width="16"
                      :path="
                        account.account_name === 'Facebook'
                          ? $options.icons[$kc('uni-facebook')]
                          : account.account_name === 'Instagram'
                          ? $options.icons[$kc('uni-instagram')]
                          : account.account_name === 'Youtube'
                          ? $options.icons[$kc('uni-youtube')]
                          : account.account_name === 'linkedIn'
                          ? $options.icons[$kc('uni-linkedin')]
                          : $options.icons[$kc('uni-web-section-alt')]
                      "
                      :icon-color="
                        account.account_name === 'Facebook'
                          ? '#316FF6'
                          : account.account_name === 'Instagram'
                          ? '#cd486b'
                          : account.account_name === 'Youtube'
                          ? '#CD201F'
                          : account.account_name === 'linkedIn'
                          ? '#0e76a8'
                          : '#e38c1d'
                      "
                    >
                    </vue-icon-base>
                  </span>
                </div>
                <div v-else>-</div>
                <div
                  v-if="employerDetail.website"
                  class="is-flex gap-05rem"
                  :class="employerDetail.website ? 'pointer' : ''"
                >
                  <span @click="openLink(employerDetail.website)">
                    <vue-icon-base
                      height="16"
                      width="16"
                      :path="$options.icons[$kc('uni-globe')]"
                      iconColor="#a7a7a7"
                    >
                    </vue-icon-base>
                  </span>
                </div>
              </span>
            </div>
          </div>
          <!-- <div
            class="box is-shadowless is-flex is-flex-direction-column has-text-black border-bottom-right-radius-16px border-bottom-left-radius-16px border-top-right-radius-16px border-top-left-radius-16px mukta"
          >
            <h3 class="is-size-5 has-text-weight-semibold">
              {{ $t('Similar Companies') }}
            </h3>
            <div
              v-for="job in similar_companies.results || []"
              :key="job.name"
              class="is-flex mb-3 px-2 py-2 d-placeitem rounded-10"
            >
              <img
                class="image is-64x64 outline rounded-10 is-paddingless"
                :src="get(job, 'logo')"
              />
              <div class="column py-0">
                <div
                  class="pointer is-size-7 has-text-weight-bold"
                  @click="openorganizationDetail(job.slug)"
                  v-text="job.name"
                ></div>
                <p
                  class="is-size-7"
                  v-text="job.industry && job.industry.name"
                ></p>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div
        v-if="blogListCount > 0"
        class="columns tiro-font is-flex is-flex-direction-column"
      >
        <blogs :blog-list="blogList"></blogs>
      </div>
      <vue-no-data v-else :loading="loading"></vue-no-data>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  uniTick,
  uniHeart,
  uniHeartAlt,
  uniWebSectionAlt,
  uniMapPinLine,
  uniUser,
  uniFacebook,
  uniInstagram,
  uniTwitter,
  uniYoutube,
  uniLinkedin,
  uniGlobe
} from '@/helpers/icons'
import { getMoment } from '@/helpers/utils/date'
import FormMixin from '@/mixins/veeValidate'
import { truncateChars } from '@/helpers/utils/common'
import VueNoData from '@/components/Commons/VueNoData'
import Blogs from '@/components/Blog/HomepageBlogList'
export default {
  truncateChars,
  getMoment,
  components: {
    Blogs,
    VueNoData,
    VueIconBase: () => import('@/components/Commons/VueIconBase.vue')
  },
  mixins: [FormMixin],
  icons: {
    uniTick,
    uniHeart,
    uniHeartAlt,
    uniWebSectionAlt,
    uniMapPinLine,
    uniUser,
    uniFacebook,
    uniInstagram,
    uniTwitter,
    uniYoutube,
    uniLinkedin,
    uniGlobe
  },
  data() {
    return {
      employerDetail: {},
      available_jobs: {},
      slug: this.$route.params.id,
      similar_companies: {},
      loading: false
    }
  },
  computed: {
    ...mapGetters({ screen: 'getScreen' }),
    blogListCount() {
      return (
        this.get(this.$store.state.collection.collectionResponses, [
          'HomepageBlogList',
          'count'
        ]) || null
      )
    },
    blogList() {
      return (
        this.get(this.$store.state.collection.collectionResponses, [
          'HomepageBlogList',
          'results'
        ]) || []
      )
    }
  },
  created() {
    this.getEmployerDetails()
    this.getEmployerAvailableJobs()
    this.getBlogs()
  },
  methods: {
    getSimilarCompany() {
      this.$axios
        .$get(
          `/api/v1/employers/organization/?industry=${
            this.employerDetail &&
            this.employerDetail.industry &&
            this.employerDetail.industry.id
          }&limit=10`
        )
        .then(resp => {
          this.similar_companies = resp
        })
        .catch(error => {
          this.getError(error)
        })
    },
    openorganizationDetail(slug) {
      if (slug) {
        if (slug) {
          this.$router.push(
            this.localePath({
              name: 'employer-detail-id',
              params: { id: slug }
            })
          )
        }
      }
    },
    async getEmployerDetails() {
      this.loading = true
      await this.$axios
        .$get(`/api/v1/employers/organization/${this.slug}/`)
        .then(resp => {
          this.employerDetail = resp
          this.loading = false
        })
        .catch(error => {
          this.getError(error)
          this.loading = false
        })
      // this.getSimilarCompany()
    },
    getEmployerAvailableJobs() {
      this.loading = true
      this.$axios
        .$get(`/api/v1/job/search/?organization=${this.slug}&limit=6`)
        .then(resp => {
          this.available_jobs = resp.results
          this.loading = false
        })
    },
    openLink(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    toggleLike(index, job) {
      const status = job.liked ? 'unlike' : 'like'
      const likeApi = `/api/v1/job/search/${job.slug}/${status}/`
      this.$axios.post(likeApi).then(({ data }) => {
        const jobIndex = this.available_jobs.findIndex(
          item => item.slug === job.slug
        )
        if (jobIndex !== -1) {
          this.$set(this.available_jobs, jobIndex, {
            ...job,
            liked: data.liked
          })
        }
      })
    },
    notify() {
      if (!this.$store.state.auth.loggedIn) {
        this.notifyUser(this.$t('Please Log in to proceed.'))
        this.setDialog({ display: true, type: 'sign-in' })
      } else {
        this.notifyError(this.$t('You cannot like this job.'))
      }
    },
    jobSearch() {
      if (this.slug) {
        this.$router.push(
          this.localePath({
            name: 'job-search',
            query: { organization: this.slug }
          })
        )
      }
    },
    getBlogs() {
      this.loading = true
      const contentUrl = `/api/v1/blogs/?limit=4`
      this.$axios
        .get(contentUrl)
        .then(({ data }) => {
          this.$store.commit('collection/setCollectionData', [
            'HomepageBlogList',
            data
          ])
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Tiro+Devanagari+Hindi&display=swap');
.tiro {
  font-family: 'Tiro Devanagari Hindi', serif;
}
@import url('https://fonts.googleapis.com/css2?family=Mukta:wght@200;300;400;500;600;700;800&family=Tilt+Neon&display=swap');
.mukta {
  font-family: 'Mukta', sans-serif;
}
.width-46percent {
  width: 46%;
}
.width-16rem {
  width: 16rem;
}
.width-19rem {
  width: 19rem;
}
.height-40vh {
  height: 40vh;
}
@media screen and (width: 425px) {
  .is-half-width-image {
    width: 100%;
  }
  .job-image-mobile {
    height: 14rem;
    width: 40%;
  }
}
@media screen and (max-width: 768px) {
  .is-half-width-image {
    width: 100%;
  }
  .job-image-mobile {
    height: 10rem;
    width: 40%;
  }
}

@media screen and (width: 768px) {
  .is-half-width-image {
    width: 49%;
  }
  .job-image-mobile {
    height: 11rem;
    width: 40%;
  }
}

@media screen and (min-width: 768px) and (min-width: 1025px) {
  .is-half-width-image {
    width: 49%;
    height: 10rem;
  }
  .job-image-mobile {
    height: 9.9rem;
    width: 40%;
  }
}

@media screen and (width: 1024px) {
  .is-half-width-image {
    width: 49%;
    height: 12rem;
  }
  .job-image-mobile {
    height: 11.9rem;
    width: 40%;
  }
}

@media screen and (max-width: 375px) {
  .job-image-mobile {
    height: 11.5rem;
    width: 40%;
  }
}

@media screen and (max-width: 1090px) {
  .padding-right-138px {
    padding-right: 100px;
  }

  .padding-left-138px {
    padding-left: 100px;
  }
}

@media screen and (min-width: 1025px) {
  .padding-right-138px {
    padding-right: 135px;
  }

  .padding-left-138px {
    padding-left: 135px;
  }
}
</style>
